import { MsalProvider } from "@azure/msal-react";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router";

import { AlertProvider, Sidebar } from "@digital-services/ui";

import "./i18n";
import "./main.css";

import { SWRConfig } from "swr";

import { msalInstance } from "./msalInstance";
import { router } from "./routes";

const swrConfig = { shouldRetryOnError: false };

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sidebar.Provider>
      {/* Setting React.Suspense fallback causes double LoadingPage from top and at the center, so avoiding for now*/}
      <React.Suspense>
        <MsalProvider instance={msalInstance}>
          <SWRConfig value={swrConfig}>
            <AlertProvider>
              <RouterProvider router={router} />
            </AlertProvider>
          </SWRConfig>
        </MsalProvider>
      </React.Suspense>
    </Sidebar.Provider>
  </React.StrictMode>
);
